// General settings for games
import { routes } from "common/navigationRoutes"

export const GAME_TIME_CONFIG = {
  // Default time in seconds for games
  DEFAULT_GAME_TIME: 60,
  // When the timer should turn red (in seconds)
  WARNING_TIME: 3,
}

export const GAME_HEADER_HEIGHT = 86
export const GAME_STEPPER_HEIGHT = 35

export const GAMES_ROLES = {
  HOST: 1, // Controls and manages the game session
  PLAYER: 2, // Participates in the game session
}

export const PERMISSIONS = {
  START_SESSION: 1, // Can start the game session
  END_SESSION: 2, // Can end the game session
  CONFIGURE: 3, // Can configure the game before starting
  ADD_PLAYER: 4, // Can add participants to the session
  KICK_PLAYER: 5, //  Can remove participants from the session
  SUBMIT_ANSWERS: 6, // Can submit answers to questions
  VIEW_RESULTS: 7, // Can view the results of the game session
  CHANGE_QUESTION: 8, // Can skip or change the current question
  SEND_CHALLENGE: 9, // Can send challenges to other players
  ACCEPT_CHALLENGE: 10, // Can accept challenges from other players
}

export const GAMES = {
  FIX_IT_RUSH: 1,
  LISTENING_RACE: 2,
  PHRASE_BUILDER: 3,
  FLASHCARD_BLITZ: 4,
  MEMORY_PALACE: 5,
  WORD_HUNT: 6,
  PHRASE_MASTER: 7,
  SENTENCE_SCRAMBLE: 8,
  WORD_MATCH: 9,
  TRANSLATION_DUEL: 10,
  SCENARIO_SNAP: 11,
  CONVERSATION_LAB: 12,
  SENTENCE_SHIFT: 13,
  VERB_MASTER: 14,
  WORD_RECALL: 15,
  CROSSWORD_QUEST: 16,
  WORDMAZE: 17,
}

export const GAME_ROUTE_MAP = {
  [GAMES.FIX_IT_RUSH]: routes.FIX_IT_RUSH_GAME,
  [GAMES.LISTENING_RACE]: routes.LISTENING_RACE_GAME,
  [GAMES.PHRASE_BUILDER]: routes.PHRASE_BUILDER_GAME,
  [GAMES.FLASHCARD_BLITZ]: routes.FLASHCARD_BLITZ_GAME,
  [GAMES.MEMORY_PALACE]: routes.MEMORY_PALACE,
  [GAMES.WORD_HUNT]: routes.WORD_HUNT,
  [GAMES.PHRASE_MASTER]: routes.PREPOSITION_MASTER_GAME,
  [GAMES.SENTENCE_SCRAMBLE]: routes.SENTENCE_SCRAMBLE,
  [GAMES.WORD_MATCH]: routes.WORD_MATCH_GAME,
  [GAMES.TRANSLATION_DUEL]: routes.TRANSLATION_DUEL,
  [GAMES.SCENARIO_SNAP]: routes.SCENARIO_SNAP,
  [GAMES.CONVERSATION_LAB]: routes.CONVERSATION_LAB,
  [GAMES.SENTENCE_SHIFT]: routes.SENTENCE_SHIFT,
  [GAMES.WORD_RECALL]: routes.WORD_RECALL_CHALLENGE_GAME,
  [GAMES.CROSSWORD_QUEST]: routes.CROSSWORD_QUEST,
  [GAMES.WORDMAZE]: routes.WORD_MAZE,
}

export const getGameRoute = (gameId) => GAME_ROUTE_MAP[gameId] || null

export const GAMES_CATEGORIES = {
  ALL_GAMES: 1,
  SPEED: 8,
  STRATEGY: 9,
  MEMORY: 10,
  ACCURACY: 11,
  SPEAKING: 12,
}

export const GAMES_MODES = {
  INDIVIDUAL: 1,
  LIVE_CLASS: 2,
  CHALLENGE: 3,
}

export const GAME_SESSION_STATUS = {
  LOBBY: 1,
  IN_PROGRESS: 2,
  RESULTS: 3,
  FINISHED: 4,
  ABANDONED: 5,
  CANCELLED: 6,
}

export const GAME_CHALLENGE_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  DECLINED: 3,
  CANCELLED: 4,
  EXPIRED: 5,
}

export const PARTICIPANTS_STATUS = {
  ACTIVE: 1,
  COMPLETED: 2,
  ABANDONED: 3,
  KICKED: 4,
}

export const CONTENT_REFERENCE_TYPES = {
  LEVEL: 1,
  MISSION: 2,
  MODULE: 3,
  FAVORITE: 4,
  FAVORITES: 4,
}

export const LEADERBOARD_RANGE_TYPES = {
  ALL: 1, // All-time accumulation. Date is ignored.
  WEEK: 2, // 7-day window always starting on a Monday.
  MONTHLY: 3, // Full calendar month starting on the 1st.
}

export const LEADERBOARD_SCOPE_TYPES = {
  GROUP: 1,
  SCHOOL: 2,
  DISTRICT: 3,
  PROVINCE: 4,
}

// Views in Games.jsx
export const VIEWS = {
  ARCADE_GAMES: 1,
  LEADERBOARD: 2,
  GAMES_HISTORY: 3,
}
